import React, { useEffect, useRef, useState } from "react";
import './CartHeaderButton.css'
import BasketComp from "../basket-comp/BasketComp";
import MahutiCountDown from "../mahuti-countdown/MahutiCountDown";
import { useSelector } from "react-redux";
import { getLocalStoragKey, setLocalStorage } from "../../store/mahutiLocalStorage";
import { useLocation } from "react-router-dom";
import { checkTimestemp } from "../../utils/orderUtils";

export default function CartHeaderButton() {
    const store = useSelector(state => state.reducer);
    const location = useLocation();
    const selectedActivitiesCount = store.selectedActivities.length || 0;
    const [openList, setOpenList] = useState(false);
    const [countDownSec, setCountDownSec] = useState(false);
    
    useEffect(() => {
        defineTimer()
    }, [store.paymentCountDown, store.currentStep])

    useEffect(() => {
        defineTimer()
    }, [])

    const defineTimer = () => {
        let localTimestemp = getLocalStoragKey('countDownTimestemp')
        let TimerSecounds = localTimestemp && checkTimestemp(localTimestemp, false)
        !TimerSecounds && setLocalStorage('countDownTimestemp', null) 
        setCountDownSec(TimerSecounds ? TimerSecounds : undefined)
    }

    const useClickOutside = (handler) => {
        const domNode = useRef();
        useEffect(() => {
            const eventHandler = (event) => {
                if (domNode.current && !domNode.current.contains(event.target)) {
                    handler();
                }
            }
            document.addEventListener("mousedown", eventHandler);
            return () => {
                document.removeEventListener('mousedown', eventHandler);
            }
        });
        return domNode;
    }

    const dropdownNode = useClickOutside(() => {
        setOpenList(false);
    })
    
    return <>  
            {countDownSec && <div className="cartHeaderButton navbar-form d-flex align-items-center">
                <MahutiCountDown showTimer={countDownSec && countDownSec !== -1} timer={countDownSec}/>
                <div ref={dropdownNode}>
                    {!location.pathname.includes('pay') && <button className="icon" type="submit" onClick={() => setOpenList(!openList)}>
                        <div className="fa-layers fa-fw">
                            <i className={`basket icon-base ${(selectedActivitiesCount > 0) && 'full'}`} />
                            <span className="icon-notification">{/*selectedActivitiesCount*/}</span>
                        </div>
                    </button>}
                    <div id='dropdown-container' className="">
                        {openList && <BasketComp isFloating={true}/>}
                    </div>
                </div>
            </div>}
        </>
}